import React, { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import ProjectModal from './components/modals/ProjectModal';
import ProjectDetailView from './components/ProjectDetailView';
import withLeftPanelWrapper from '../../../utils/hoc/leftPanelWithDetailWrapper';

const ProjectWizard = lazy(() => import('./components/modals/ProjectWizard'));

function Project({ openDialog, isEdit, handleSubmit, handleCreated, handleEdit, handleClose }) {
  const { detail } = useSelector((state) => state.contractListing);

  return (
    <div className="w-full">
      {openDialog && isEdit && (
        <Suspense fallback={<div>Loading...</div>}>
          <ProjectModal
            submitForm={handleSubmit}
            title="Editovat akci"
            visible={openDialog}
            formProps={detail}
            onClose={handleClose}
          />
        </Suspense>
      )}
      {openDialog && !isEdit && (
        <Suspense fallback={<div>Loading...</div>}>
          <ProjectWizard visible={openDialog} onClose={handleClose} onCreated={handleCreated} />
        </Suspense>
      )}
      <ProjectDetailView data={detail} makeEditable={handleEdit} />
    </div>
  );
}

export default withLeftPanelWrapper(Project, 'contractListing');
